<template>
    <div class="side-nav-input">
        <slot name="placeholder-icon"></slot>
        <input type="text" :value="value" @input="$emit('input', $event.target.modelValue)"
               :placeholder="placeholder">
    </div>
</template>

<script>
export default {
    name: 'SideNavInput',
    props: {
        value: String,
        placeholder: String
    }
};
</script>
